import { Loader2 } from "lucide-react";

export const Loading = ({ label = "Chargement…", full = false }) => (
  <div className={`flex flex-col items-center justify-center gap-3 text-slate-400 ${full ? "min-h-[60vh]" : "py-16"}`} data-testid="loading">
    <Loader2 className="w-8 h-8 animate-spin text-primary" />
    <span className="text-sm font-semibold">{label}</span>
  </div>
);

export const ErrorMessage = ({ message = "Une erreur est survenue." }) => (
  <div className="bg-red-50 border border-red-200 text-red-600 rounded-2xl px-4 py-3 text-sm font-semibold" data-testid="error-message">
    {message}
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle }) => (
  <div className="flex flex-col items-center justify-center text-center py-14 text-slate-400" data-testid="empty-state">
    {Icon && <Icon className="w-12 h-12 mb-3 text-slate-300" />}
    <p className="font-extrabold text-slate-500">{title}</p>
    {subtitle && <p className="text-sm mt-1 max-w-xs">{subtitle}</p>}
  </div>
);
